var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0576 0.919922H1.05762L0.0576172 1.91992V21.9199H1.46762L8.05762 15.3299L14.6476 21.9199H16.0576V1.91992L15.0576 0.919922ZM14.0576 18.5099L8.76762 13.2199H7.35762L2.06762 18.5099V2.91992H14.0676V18.5099H14.0576Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVector);
export default __webpack_public_path__ + "static/1770312069/media/icon-vector.37893e6b5222fe4fd0eaddc3dd1a3487.svg";
export { ForwardRef as ReactComponent };